import React from 'react';

import { VideoDifficulty } from '../../../types';
import IKImage from '../../IKImage/IKImage';
import { LightTooltip } from '../LightTooltip';
import useStyles from './styles';

interface DifficultyIconProps {
  difficulty: VideoDifficulty;
}

const DifficultyIcon: React.FC<DifficultyIconProps> = ({ difficulty, ...rest }) => {
  const classes = useStyles();

  return (
    <LightTooltip
      data-testid="difficultyIcon"
      placement="top"
      title={difficulty?.title}
      className={classes.difficultyBtn}
      {...rest}
    >
      <div className={classes.difIconWrap}>
        <IKImage
          className={classes.difIcon}
          path={difficulty?.icon_url}
          alt={difficulty?.title}
          draggable={false}
        />
      </div>
    </LightTooltip>
  );
};

export default DifficultyIcon;
